import { useCallback } from "react";
import styles from "./listFilter.module.css";
import { useDispatch } from "react-redux";
import { setFilter } from "../../../features/filter/commonFilterSlice";
import { CustomDropdown } from "../customDropdown/CustomDropdown ";
export const ListFilter = ({
  label,
  optionList,
  filterName,
  filterSetter = setFilter,
}) => {
  const dispatch = useDispatch();

  const handleFilterBy = useCallback(
    (e) => {
      const { property, value } = e;
      if (!property) return; // safety check

      dispatch(filterSetter({ property, value }));
    },
    [dispatch]
  );
  return (
    <div className={styles.filterContainer}>
      <section className={styles.inputDropDown}>
        <p htmlFor={label}>{label}</p>
        <CustomDropdown
          options={optionList}
          placeholder="All"
          fieldName={filterName}
          handleFilterBy={handleFilterBy}
        />
      </section>
    </div>
  );
};
